
import {defineComponent, onMounted, ref} from 'vue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {isFirstTime} from '@/state/popups';
import Popup from '@/components/Popup.vue';
import HowTo from '@/components/HowTo.vue';
import About from '@/components/About.vue';

export default defineComponent({
	components: {About, HowTo, FontAwesomeIcon, Popup},
	setup() {
		const howToPopup = ref<typeof Popup>();
		const aboutPopup = ref<typeof Popup>();

		onMounted(() => {
			if (isFirstTime.value) {
				howToPopup.value!.toggle(true);
			}
		});
		const howToClosed = () => {
			isFirstTime.value = false;
		};

		const openAbout = () => aboutPopup.value?.toggle(true);
		const openHowTo = () => howToPopup.value?.toggle(true);
		const closeHowTo = () => howToPopup.value?.toggle(false);

		return {
			howToPopup, aboutPopup,
			openAbout, openHowTo,
			howToClosed, closeHowTo,
		};
	},
});
